export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/frequently-asked-questions/why-i-cant-disable-price-genius-on-ad-unit-level' as const
